import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base";
import { getESGReqHeader } from "./tool-service";

// B2050101	查詢排放源來源
export const queryEmissionSourceList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050101"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050101")}`, method: "post", data: ReqBody });
};

// B2050102 查詢排放源係數清單
export const queryEmissionSourceFactorList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050102"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050102")}`, method: "post", data: ReqBody });
};

// B2050103 查詢排放源係數詳情
export const queryEmissionSourceFactorDetail = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050103"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050103")}`, method: "post", data: ReqBody });
};

// B2050104 排放源排序
export const updateEmissionSourceSort = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050104"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050104")}`, method: "post", data: ReqBody });
};

// B2050111 Before
export const B2050111Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050111"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050111", true)}`, method: "post", data: ReqBody });
};

// B2050110 查詢GWP清單
export const queryGwpList = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050110"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050110")}`, method: "post", data: ReqBody });
};

// B2050111 單筆GWP資料更新
export const updateGwp = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("B2050111"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("B2050111")}`, method: "post", data: ReqBody });
};
